import { GPTGameIcon } from './types';

export const LuckyPigeonIcon: GPTGameIcon = (props) => (
  <svg
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <defs>
      <linearGradient
        id="paint0_linear_2135_11960"
        x1="13.0014"
        y1="-1.15756"
        x2="13.0014"
        y2="16.5713"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#7CBDFF" />
        <stop offset="1" stopColor="#6A00FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2135_11960"
        x1="12.2463"
        y1="13.2594"
        x2="11.2458"
        y2="6.81404"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#A396CA" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2135_11960"
        x1="15.9307"
        y1="10.0283"
        x2="18.4445"
        y2="10.0283"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFBC00" />
        <stop offset="1" stopColor="#FF6700" />
      </linearGradient>
    </defs>
    <path
      d="M6.90096 21.1665L7.21595 23.1737C7.21595 23.1737 6.335 23.435 6.24558 23.6306C6.15718 23.8262 7.25253 23.9503 8.10604 23.9036C8.95955 23.8576 9.11603 23.8123 9.2786 23.6306C9.44118 23.4488 9.46049 21.7694 9.46049 21.7694L6.89994 21.1665H6.90096Z"
      fill="#E02E60"
    />
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.52}>
      <path
        d="M7.02211 21.9358C7.73642 22.1774 8.62549 22.9533 8.8155 23.108C8.95064 23.2175 8.85107 23.5707 8.72507 23.8561C9.05835 23.8152 9.16707 23.7547 9.27884 23.6306C9.44141 23.4488 9.46072 21.7694 9.46072 21.7694L6.90018 21.1665L7.02109 21.9358H7.02211Z"
        fill="#A60AC2"
      />
    </g>
    <path
      d="M17.954 21.1387L17.639 23.1459C17.639 23.1459 18.52 23.4071 18.6094 23.6028C18.6978 23.7984 17.6024 23.9224 16.7489 23.8757C15.8954 23.8298 15.7389 23.7845 15.5764 23.6028C15.4138 23.421 15.3945 21.7416 15.3945 21.7416L17.955 21.1387H17.954Z"
      fill="#E02E60"
    />
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.52}>
      <path
        d="M18.6095 23.6013C18.5211 23.4057 17.6391 23.1444 17.6391 23.1444L17.9541 21.1372L15.3936 21.7401C15.3936 21.7401 15.3987 22.1452 15.4231 22.5787C16.0297 22.7159 16.2908 22.986 16.4412 23.178C16.5458 23.3123 16.6515 23.629 16.7104 23.8713C16.7236 23.8721 16.7358 23.8728 16.749 23.8735C17.6026 23.9195 18.6979 23.7962 18.6095 23.6006V23.6013Z"
        fill="#A60AC2"
      />
    </g>
    <path
      d="M17.3597 13.2122C18.9175 13.2122 20.1804 11.3921 20.1804 9.14687C20.1804 6.90165 18.9175 5.08154 17.3597 5.08154C15.8019 5.08154 14.5391 6.90165 14.5391 9.14687C14.5391 11.3921 15.8019 13.2122 17.3597 13.2122Z"
      fill="white"
    />
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.52}>
      <path
        d="M16.8432 12.7803C18.7388 12.7803 20.2755 11.0569 20.2755 8.93095C20.2755 6.80498 18.7388 5.08154 16.8432 5.08154C14.9476 5.08154 13.4109 6.80498 13.4109 8.93095C13.4109 11.0569 14.9476 12.7803 16.8432 12.7803Z"
        fill="#4F3699"
      />
    </g>
    <path
      d="M19.3461 6.72343C19.9395 7.65987 19.9141 8.58463 19.2882 8.78973C18.6623 8.99482 17.6736 8.40143 17.0802 7.46572C16.4868 6.52928 16.5122 5.60452 17.1381 5.39942C17.7641 5.19432 18.7527 5.78772 19.3461 6.72343Z"
      fill="#D7D1E8"
    />
    <path
      d="M3.16183 18.435L6.44786 16.3577C6.44786 16.3577 4.14743 8.87863 8.22194 4.54458C12.2965 0.210537 14.1376 -0.11937 14.4658 0.163825C14.794 0.447019 12.4936 2.60966 12.4936 2.60966C12.4936 2.60966 14.5969 1.71702 15.4514 1.93233C16.3059 2.14692 15.1232 2.8549 15.1232 2.8549C15.1232 2.8549 18.4092 3.09066 19.2638 8.09546C20.1183 13.1003 20.7025 17.6861 19.592 19.7568C18.2771 22.2078 8.55014 24.7142 3.16081 18.435H3.16183Z"
      fill="#6E4AFF"
    />
    <path
      d="M15.123 2.85388C15.123 2.85388 16.3057 2.14589 15.4512 1.93131C14.5967 1.71672 12.4934 2.60864 12.4934 2.60864C12.4934 2.60864 14.7938 0.445996 14.4656 0.162801C14.1374 -0.120394 12.2963 0.210243 8.22174 4.54356C4.14723 8.87761 6.44664 16.3567 6.44664 16.3567C6.44664 16.3567 12.6661 20.3813 20.1811 17.1063C20.3051 14.7459 19.8478 11.5183 19.2625 8.09444C18.408 3.08963 15.122 2.85388 15.122 2.85388H15.123Z"
      fill="url(#paint0_linear_2135_11960)"
    />
    <g
      style={{
        mixBlendMode: 'screen'
      }}
      opacity="0.16">
      <path
        d="M16.2899 16.7775C16.421 16.071 16.9565 15.5389 17.4859 15.5892C18.0152 15.6396 18.3384 16.2542 18.2083 16.9607C18.0772 17.6672 17.5417 18.1993 17.0124 18.1489C16.483 18.0986 16.1599 17.484 16.2899 16.7775Z"
        fill="#FFAD17"
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.52}>
      <path
        d="M15.7562 9.88037C15.7095 10.6008 16.0072 11.7686 16.8069 11.9438C17.6065 12.1189 18.1755 10.5329 18.1755 10.5329L15.7562 9.8811V9.88037Z"
        fill="#2E4BA3"
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.52}>
      <path
        d="M14.4091 0.0883789C13.4743 0.348947 12.3688 1.73135 12.4948 2.60939C13.5861 1.51165 14.6936 0.412447 14.4091 0.0883789Z"
        fill="#2E4BA3"
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.52}>
      <path
        d="M10.963 13.4694C13.0683 13.4694 14.7743 11.5921 14.7743 9.27545C14.7743 6.9588 13.0683 5.08154 10.963 5.08154C10.5077 5.08154 10.0718 5.16986 9.66744 5.33043C8.29573 7.43688 8.03154 9.99001 8.12705 12.076C8.82511 12.9307 9.83713 13.4686 10.963 13.4686V13.4694Z"
        fill="#2E4BA3"
      />
    </g>
    <path
      d="M6.44775 16.3572C6.44775 16.3572 7.40694 18.5476 13.473 19.0636C16.7885 19.3453 18.9121 18.4337 20.1568 17.4819C20.1771 17.2338 20.1903 16.9732 20.1974 16.7039C15.5082 19.3358 8.38543 17.4418 6.44775 16.3564V16.3572Z"
      fill="#E2EED6"
    />
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.52}>
      <path
        d="M19.2648 8.09486C18.4103 3.09006 15.1243 2.8543 15.1243 2.8543C15.1243 2.8543 16.2186 2.19887 15.5398 1.95801C14.9983 2.57987 13.6489 2.90321 13.6489 2.90321C17.6025 4.49946 20.6955 16.6834 17.189 19.7197C15.2238 21.4211 11.5436 21.4722 8.48109 20.8919C8.81233 20.4503 9.12427 19.8737 9.19032 19.3132L7.11445 20.5817C5.69803 20.2036 4.52851 19.7066 3.90463 19.2183C4.67991 19.9628 5.52428 20.554 6.40624 21.0145C6.40624 21.0145 6.42148 21.0226 6.45501 21.0386C6.87161 21.2539 7.29735 21.4393 7.72715 21.5992C7.73833 21.6043 7.74951 21.6086 7.7617 21.6138C7.7617 21.6138 7.76271 21.613 7.76373 21.6123C12.8492 23.4764 18.6054 21.6013 19.5951 19.7562C20.7056 17.6848 20.1204 13.0989 19.2669 8.09486H19.2648Z"
        fill="#2E4BA3"
      />
    </g>
    <path
      d="M15.1233 2.8541C14.1986 2.78476 13.1957 2.96723 13.1957 2.96723L15.1233 2.8541Z"
      fill="#36A5EB"
    />
    <path
      d="M15.111 2.94116C15.0317 2.94189 14.9545 2.93605 14.8752 2.93824C14.797 2.93605 14.7177 2.93605 14.6395 2.93751C14.482 2.94043 14.3235 2.94189 14.165 2.94919C14.0065 2.95503 13.848 2.96379 13.6874 2.97255C13.5279 2.98203 13.3674 2.99371 13.2078 3.00393H13.2058C13.1774 3.00612 13.1509 2.99079 13.1489 2.96963C13.1469 2.95284 13.1611 2.93678 13.1824 2.93094C13.3379 2.88715 13.4954 2.85576 13.6549 2.82803C13.8144 2.79956 13.977 2.77986 14.1406 2.76453C14.4678 2.73533 14.8031 2.72803 15.1343 2.76745C15.2004 2.77548 15.2461 2.82 15.2349 2.86817C15.2248 2.91051 15.175 2.94116 15.1171 2.94189H15.1089L15.111 2.94116Z"
      fill="#002657"
    />
    <path
      d="M10.963 12.9039C13.0679 12.9039 14.7743 11.1531 14.7743 8.99323C14.7743 6.83341 13.0679 5.08252 10.963 5.08252C8.85804 5.08252 7.15164 6.83341 7.15164 8.99323C7.15164 11.1531 8.85804 12.9039 10.963 12.9039Z"
      fill="url(#paint1_linear_2135_11960)"
    />
    <path
      d="M20.2768 8.9315C20.2768 9.5176 20.1589 10.073 19.9506 10.5708C20.4962 10.0789 20.8356 9.38841 20.8356 8.62276C20.8356 7.58049 20.2056 6.67617 19.2841 6.2251C19.8978 6.92068 20.2768 7.87609 20.2768 8.9315Z"
      fill="#002657"
    />
    <path
      d="M10.0343 11.6965C11.6263 11.6965 12.9169 10.4861 12.9169 8.99304C12.9169 7.49994 11.6263 6.28955 10.0343 6.28955C8.44224 6.28955 7.15164 7.49994 7.15164 8.99304C7.15164 10.4861 8.44224 11.6965 10.0343 11.6965Z"
      fill="#002657"
    />
    <g
      style={{
        mixBlendMode: 'soft-light'
      }}
      opacity={0.24}>
      <path
        d="M10.5026 7.17425C10.659 7.46036 10.5036 7.77202 10.154 7.87128C9.8045 7.97055 9.394 7.81873 9.23753 7.53262C9.08105 7.2465 9.23651 6.93484 9.58604 6.83558C9.93558 6.73632 10.3461 6.88813 10.5026 7.17425Z"
        fill="white"
      />
    </g>
    <g
      style={{
        mixBlendMode: 'soft-light'
      }}
      opacity={0.24}>
      <path
        d="M10.2265 11.482C11.1605 11.2174 11.4935 10.2305 10.9705 9.27763C10.4474 8.32474 9.26626 7.76673 8.33231 8.03127C7.39837 8.2958 7.06528 9.28272 7.58835 10.2356C8.11142 11.1885 9.29257 11.7465 10.2265 11.482Z"
        fill="white"
      />
    </g>
    <path
      d="M12.775 8.77168C13.592 8.54026 14.087 8.04775 13.8805 7.67163C13.674 7.2955 12.8444 7.17819 12.0273 7.4096C11.2103 7.64101 10.7154 8.13353 10.9219 8.50965C11.1283 8.88578 11.958 9.00309 12.775 8.77168Z"
      fill="white"
    />
    <path
      d="M5.71337 18.9714C5.31608 18.7218 4.25833 18.4065 4.05816 18.9714C2.86629 21.6092 5.84445 22.4501 8.69254 19.8181C8.98924 19.5437 9.19652 19.3196 9.32861 19.1386L5.71337 18.9714Z"
      fill="#8F40FF"
    />
    <g
      style={{
        mixBlendMode: 'screen'
      }}
      opacity={0.24}>
      <path
        d="M7.84492 19.1173C7.52892 19.2786 7.3826 19.5202 7.51774 19.6567C7.65288 19.7931 8.01867 19.7727 8.33467 19.6107C8.65068 19.4494 8.79699 19.2078 8.66185 19.0713C8.52671 18.9348 8.16092 18.9552 7.84492 19.1173Z"
        fill="#B3FF75"
      />
    </g>
    <path
      d="M4.05807 18.9714C3.52259 20.1567 3.82945 20.9793 4.58847 21.2866C4.67179 21.315 4.75612 21.3421 4.84249 21.3661C3.34579 20.7436 5.27941 18.7751 5.27941 18.7751C5.27941 18.7751 5.27636 18.7736 5.27128 18.7721C4.80185 18.6152 4.20236 18.5605 4.05706 18.9714H4.05807Z"
      fill="#A667FF"
    />
    <path
      d="M4.36968 18.7451C4.37374 18.8086 4.41337 18.8852 4.46824 18.9575C4.52311 19.0305 4.5922 19.1027 4.66942 19.1699C4.7436 19.24 4.82692 19.3049 4.91328 19.3691C4.99965 19.4326 5.0911 19.4947 5.18763 19.5458L5.19068 19.5472C5.20998 19.5574 5.21405 19.5772 5.19982 19.591C5.18864 19.6027 5.16832 19.6064 5.15003 19.602C5.01997 19.5684 4.90922 19.5166 4.80151 19.4618C4.69482 19.4064 4.59626 19.3429 4.50177 19.2757C4.41032 19.2064 4.32192 19.1327 4.25181 19.0458C4.18272 18.9597 4.11972 18.8604 4.1248 18.74C4.12683 18.6918 4.18373 18.6539 4.2508 18.6553C4.31481 18.6568 4.3646 18.6933 4.36765 18.7385V18.7451H4.36968Z"
      fill="#002657"
    />
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.52}>
      <path
        d="M9.02073 19.4981C7.70998 20.4922 3.81532 20.6148 4.10795 18.8726C4.08865 18.9018 4.07137 18.9346 4.05816 18.9711C2.86629 21.6089 5.84445 22.4497 8.69254 19.8178C8.81752 19.7017 8.92624 19.5959 9.02073 19.4973V19.4981Z"
        fill="#2E4BA3"
      />
    </g>
    <path
      d="M4.19937 18.9349C4.18413 19.0627 4.16889 19.1897 4.1821 19.3174C4.19124 19.4444 4.21563 19.5714 4.25729 19.6962C4.29793 19.821 4.35585 19.9429 4.42393 20.0626C4.49099 20.1823 4.57329 20.3006 4.66271 20.4108L4.66576 20.4137C4.68404 20.4356 4.67388 20.4641 4.6434 20.4772C4.61698 20.4881 4.58549 20.4845 4.56516 20.4699C4.42596 20.3677 4.32028 20.2531 4.2268 20.1305C4.13434 20.0079 4.06423 19.8772 4.01343 19.7422C3.96161 19.6072 3.92604 19.4685 3.91995 19.3276C3.90572 19.1875 3.92706 19.0459 3.95856 18.9079C3.96974 18.8605 4.03172 18.8277 4.09878 18.8357C4.16178 18.843 4.20547 18.8846 4.20039 18.9291V18.9349H4.19937Z"
      fill="#002657"
    />
    <path
      d="M7.46824 23.417C7.20914 23.6374 7.21625 23.8958 7.21625 23.8958L7.46824 23.417Z"
      fill="#FF9900"
    />
    <path
      d="M17.3869 23.3882C17.646 23.6086 17.6388 23.867 17.6388 23.867L17.3869 23.3882Z"
      fill="#FF9900"
    />
    <path
      d="M3.16163 18.4344C3.16163 18.4344 2.87611 16.4089 3.01024 16.1513C3.14436 15.8936 4.61362 17.2848 3.16163 18.4344Z"
      fill="#9B54FF"
    />
    <path
      d="M3.16169 18.4349C1.81435 18.032 0.856183 17.1722 1.1854 15.9044C1.51461 14.6366 2.89344 17.6131 3.16169 18.4349Z"
      fill="#9B54FF"
    />
    <path
      d="M15.931 9.97477C15.5124 9.81566 15.8325 7.5844 17.0406 7.60265C18.2487 7.62017 18.1989 9.86967 17.6564 10.0288C17.1138 10.1879 15.931 9.9755 15.931 9.9755V9.97477Z"
      fill="#E2EED6"
    />
    <path
      d="M15.9307 9.97503C15.9307 8.38169 17.6804 7.42555 18.4445 9.99254C17.2455 12.861 16.202 11.4443 15.9307 9.97503Z"
      fill="url(#paint2_linear_2135_11960)"
    />
    <g
      style={{
        mixBlendMode: 'soft-light'
      }}
      opacity="0.7">
      <path
        d="M17.2539 9.20708C17.0486 9.46181 16.7194 9.60048 16.5182 9.51728C16.317 9.43334 16.3191 9.15963 16.5243 8.90418C16.7296 8.64945 17.0588 8.51077 17.26 8.59398C17.4612 8.67791 17.4591 8.95162 17.2539 9.20708Z"
        fill="white"
      />
    </g>
    <path
      d="M16.8515 10.0129C17.1045 9.92383 17.387 9.88661 17.6644 9.88223C17.8036 9.87858 17.9428 9.88661 18.08 9.90047C18.2192 9.91653 18.3482 9.93843 18.4905 9.98222C18.5524 10.0012 18.5809 10.053 18.5545 10.0975C18.5321 10.1348 18.4793 10.1552 18.4264 10.1494L18.4122 10.1479C18.3004 10.137 18.1663 10.1267 18.0424 10.1187C17.9164 10.11 17.7904 10.1034 17.6644 10.1005C17.5384 10.0983 17.4124 10.099 17.2864 10.1041C17.1614 10.1107 17.0364 10.1209 16.9094 10.1355H16.9064C16.8566 10.1413 16.8098 10.1172 16.8017 10.0822C16.7956 10.053 16.8159 10.0253 16.8515 10.0129Z"
      fill="#002657"
    />
    <path
      d="M17.0549 11.7409C17.0407 11.7409 17.0265 11.7409 17.0123 11.7395C16.3569 11.7015 15.9555 10.7716 15.8102 9.98703C15.8102 9.98338 15.8092 9.97973 15.8092 9.97535C15.8092 9.09803 16.3345 8.37106 17.0041 8.31997C17.3171 8.29589 18.0985 8.40975 18.5648 9.97462C18.5689 9.98921 18.5679 10.0038 18.5628 10.0184C18.0792 11.1767 17.5853 11.7409 17.056 11.7409H17.0549ZM16.0531 9.96951C16.2207 10.8709 16.6323 11.5417 17.0316 11.565C17.2155 11.5753 17.7083 11.4424 18.319 9.98922C18.0243 9.01336 17.5427 8.45427 17.0295 8.49368C16.5611 8.52945 16.0551 9.10314 16.0531 9.96951Z"
      fill="#002657"
    />
  </svg>
);
